export const ENTRY_ORIGIN_VARIANTS = { 
  PROFILE: "PROFILE", 
  CART: "CART", 
} as const;

export type EntryOriginVariants = typeof ENTRY_ORIGIN_VARIANTS[keyof typeof ENTRY_ORIGIN_VARIANTS];
export type EntryOriginType = EntryOriginVariants | "" | undefined;
export interface ShopOriginConfiguration {
  country: string;
  market: string;
  lang: string;
  entryLang?: string;
  entryISO?: string;
  storeId?: string;
  entryOrigin?: EntryOriginType;
}

export interface Shop {
  id?: string;
  enabled?: boolean;
  languages?: Languages;
  locale?: Locale;
  marketIso?: string;
}

export interface MarketPolicies {
  name?: string | null;
  url?: string | null;
  type: "STATE" | "COUNTRY";
  value: string;
}

export interface Market {
  id?: string;
  enabled?: boolean;
  languages?: Languages;
  locale?: Locale;
}

export interface MarketApiResponse {
  id?: string;
  resellStoreId?: string;
  countryIso?: string;
  marketIso?: string;
  isMarketIso?: boolean;
  enabled?: boolean;
  languages?: Languages;
  minOfferPrice?: number;
  locale?: Locale[];
  statesRestricted?: string[];
  zipCodesRestricted?: string[];
  termsAndConditionsUrl?: string;
  privacyPolicyUrl?: string;
  omnibusUrl?: string;
  legalText?: string;
  legal: MarketAPILegalContent;
  expeditionDivision?: boolean;
  rgpd: RGPDContent;
  layersDataProtection: LayersDataProtectionContent;
  host: string;
  isMarketTaxes?: boolean;
}

export interface MarketAPILegalContent {
  feedTitle: string;
	feedDescription: string;
	legalTitle: string;
	legalDescription: string;
  policies?: MarketPolicies[];
  dacEnabled?: boolean;
  digitalServicesContact?: string;
}

export interface Languages {
  availableLanguages: AvailableLanguage[];
  default: string;
}

export interface RGPDContent {
  isEnabled: boolean;
  showPopup: boolean;
}

export interface LayersDataProtectionContent {
  dataController:	string
  purposesAndLegalBases: string
  recipients: string
  rights: string
  additionalInformation: string
}

export interface AvailableLanguage {
  id: number;
  code: string;
  locale: string;
  name: string;
  countryName: string;
  isSeoIrrelevant: boolean;
  isSeoProductIrrelevant: boolean;
  direction: string;
  formats: Formats;
}

export interface Formats {
  number: NumberFormat;
  date: DateFormat;
}

export interface NumberFormat {
  decimalSeparator: string;
  thousandsSeparator: string;
}

export interface DateFormat {
  shortDate: string;
  longDate: string;
}

export interface Locale {
  defaultCurrency: string;
  defaultLocale: string;
  availableLocales: AvailableLocale[];
  availableCurrencies: AvailableCurrency[];
}

export interface AvailableLocale {
  codeLocale: string;
  isBankBicMandatory: string;
  isBankInnMandatory: string;
  isBankSwift: string;
  isCompoundName: string;
  isLastNameFirst: string;
}

export interface AvailableCurrency {
  currencyCode: string;
  currencySymbol: string;
  currencyFormat: string;
  currencyDecimals: string;
  conversionRates: ConversionRate[];
}

export interface ConversionRate {
  from: string;
  to: string;
  rate: number;
}
